<template>
  <v-container fluid>
    <v-row
      class="rounded elevation-3 white pa-4">
      <v-col
        cols="12"
        class="d-flex flex-row justify-space-between align-center">
        <h2>
          สร้าง Location
        </h2>
      </v-col>
      <v-col
        :cols="results.length ? '6' : '12'"
        class="pa-6">
        <validation-observer
          ref="createLocationForm"
          tag="form"
          @submit.prevent="submitForm()">
          <h3 class="mb-4">
            Form Create
          </h3>
          <autocomplete-form
            v-model="warehouse"
            :disabled="loadingCreate"
            class="mb-4"
            :items="warehouses"
            item-text="name"
            item-value="id"
            out-field-label="Warehouse"
            placeholder="Select"
            name="Warehouse"
            return-object
            outlined
            :rules="{ required: true }" />
          <text-area-form
            v-model="locationText"
            :disabled="loadingCreate"
            out-field-label="Locations (บรรทัดละ 1 location)"
            outlined
            :rules="locationRules"
            placeholder="Locations"
            name="Locations" />
          <v-btn
            :loading="loadingCreate"
            color="secondary"
            type="submit">
            CREATE
          </v-btn>
        </validation-observer>
      </v-col>
      <v-divider
        v-if="results.length"
        vertical></v-divider>
      <v-col
        v-if="results.length"
        cols="6"
        class="pa-6">
        <div class="d-flex justify-space-between">
          <h3 class="mb-4">
            Create Results
          </h3>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="green"
            @click="downloadCsv(results)">
            EXPORT
            <v-icon class="ml-1">
              mdi-file
            </v-icon>
          </v-btn>
          <v-btn
            color="secondary"
            @click="printLabel(results)">
            PRINT
            <v-icon class="ml-1">
              mdi-printer
            </v-icon>
          </v-btn>
        </div>
        <v-simple-table>
          <thead>
            <tr>
              <th>Location</th>
              <th>Status</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(result, index) in results"
              :key="`result-${index}`"
              :class="result.status === 'created' ? 'green--text' : 'red--text' ">
              <td>{{ result.name }}</td>
              <td>{{ result.status }}</td>
              <td>{{ result.message }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StockLocationProvider from '@/resources/StockLocation.provider'
import { extend } from 'vee-validate'
import { mapActions } from 'vuex'
import { ExportToCsv } from 'export-to-csv'

extend('no_colon', {
  validate: (value) => !value.includes(':'),
  message: "Cannot contain ':'"
})

const stockLocationService = new StockLocationProvider()

export default {
  data () {
    return {
      loadingAttribute: true,
      loading: false,
      results: [],
      locationText: '',
      warehouse: null,
      locationRules: {
        required: true,
        no_colon: true
      },
      loadingCreate: false
    }
  },
  computed: {
    warehouses () {
      return this.$store.getters['Store/mapWarehouse']?.filter((v) => v.id !== 0) || []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions({
      setPrintLocations: 'StockLocation/setPrintLocations'
    }),
    async init () {
      try {
        this.loadingAttribute = true

        if (this.warehouses.length) {
          if (this.$route.query.warehouse) this.warehouse = this.warehouses.find((w) => Number(this.$route.query.warehouse) === w.id) || null
          else this.warehouse = this.warehouses[0]
        }
      } catch (error) {
        console.error('getAttributes', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loadingAttribute = false
      }
    },
    async createLocations () {
      try {
        this.loadingCreate = true
        const names = this.locationText.split('\n').filter((loText) => loText)
        const { data } = await stockLocationService.createLocations({
            warehouse: this.warehouse,
            names
        })
        this.results = data
      } catch (error) {
          this.$store.dispatch('Components/setSnackbar', {
              value: true,
              message: error.message || error,
              type: 'error'
          })
      } finally {
        this.loadingCreate = false
      }
    },
    async submitForm () {
        const valid = await this.$refs.createLocationForm.validate()
        if (valid) {
            this.createLocations()
        }
    },
    printLabel (results) {
      this.setPrintLocations(results)
      this.$router.push({ name: 'PrintLocation', query: { warehouse: this.warehouse.id } })
    },
    async downloadCsv (results) {
      const payload = results.map((re) => ({ name: re.name, qrcode: `location::${re.id}` }))
      const options = {
        filename: `${this.warehouse.name.toLowerCase()}_locations_qrcode`,
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(payload)
    }
  }
}
</script>

<style scoped>
img {
  max-height: 80px;
}
</style>
